export default __webpack_public_path__ + "static/media/user_default.4aa827c3.jpeg";